var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIntelliwriter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 32.19",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1ca564;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n\n      .cls-3 {\n        fill: #20d587;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exntensionBack"
  }, /*#__PURE__*/React.createElement("g", {
    id: "intelliwriter_12-09-2021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m0,31.41V2.32h8.01v29.1H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m13.91,31.41V11.36h6.48v4.06c.77-1.45,1.89-2.67,3.26-3.58,1.34-.78,2.88-1.18,4.43-1.13,1.18-.02,2.35.19,3.45.62.96.38,1.81,1,2.48,1.8.55.73.94,1.57,1.13,2.46.26,1.43.38,2.88.34,4.33v11.49h-7.08v-10.75c0-1.6-.26-2.77-.78-3.5-.52-.73-1.36-1.1-2.52-1.1-1.47,0-2.54.54-3.22,1.63s-1.02,2.85-1.01,5.29v8.43h-6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m41.58,31.41v-15.06h-3v-4.99h3v-6h6.97v6h3v4.99h-3v15.06h-6.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m75.67,22.79h-15.27c.01,1.55.41,2.75,1.19,3.59.78.84,1.88,1.26,3.3,1.27.94.03,1.88-.18,2.71-.61.74-.4,1.33-1.03,1.68-1.8l5.33,2.15c-.66,1.56-1.86,2.82-3.38,3.56-1.62.84-3.6,1.25-5.94,1.25-3.5,0-6.31-.97-8.43-2.91s-3.18-4.51-3.17-7.7c0-3.13,1.06-5.73,3.17-7.79,2.11-2.07,4.8-3.09,8.05-3.08,3.33,0,5.95,1.05,7.87,3.14s2.88,4.96,2.88,8.61v.34Zm-6.97-3.99c-.08-1.04-.55-2.02-1.3-2.74-.73-.69-1.71-1.06-2.71-1.03-1-.05-1.99.29-2.75.94-.68.63-1.14,1.57-1.36,2.83h8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m79.92,31.41V.61h7.09v30.8h-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m92.62,31.41V.61h7.1v30.8h-7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m104.97,5.08c-.02-1.03.39-2.03,1.14-2.74,1.54-1.5,4-1.51,5.54-.02.74.72,1.15,1.72,1.13,2.76.02,1.05-.39,2.06-1.14,2.8-.72.75-1.73,1.17-2.77,1.16-1.04,0-2.03-.42-2.74-1.17-.75-.73-1.16-1.74-1.15-2.78Zm.37,26.33V11.36h7.1v20.06h-7.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m164.33,30.2V10.13h6.68v4.73c.55-1.53,1.53-2.87,2.81-3.87,1.27-.88,2.79-1.34,4.33-1.29.28,0,.56,0,.85.03s.57.05.86.09l-.67,6.44c-.41-.14-.83-.25-1.25-.32-.39-.07-.78-.1-1.18-.11-1.71,0-3.04.53-3.99,1.58s-1.41,2.55-1.4,4.48v8.31h-7.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m182.32,3.87c-.02-1.03.4-2.03,1.14-2.74,1.54-1.5,4-1.5,5.54,0,.74.72,1.15,1.72,1.12,2.76.02,1.05-.39,2.06-1.14,2.8-.72.75-1.73,1.17-2.78,1.15-1.04.01-2.03-.41-2.74-1.17-.75-.74-1.17-1.75-1.16-2.8Zm.37,26.33V10.13h7.09v20.07h-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m196.28,30.2v-15.06h-3.01v-5.01h3v-5.98h6.97v5.98h3v5.01h-3v15.06h-6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m230.36,21.58h-15.26c0,1.55.4,2.75,1.19,3.59.79.84,1.9,1.26,3.32,1.26.94.03,1.88-.18,2.71-.61.74-.41,1.32-1.03,1.68-1.8l5.32,2.15c-.65,1.56-1.85,2.82-3.38,3.56-1.62.84-3.6,1.25-5.94,1.25-3.49,0-6.3-.97-8.42-2.91s-3.17-4.51-3.17-7.7c0-3.13,1.06-5.73,3.17-7.79,2.11-2.07,4.79-3.1,8.02-3.1,3.32,0,5.95,1.05,7.87,3.14,1.92,2.09,2.88,4.96,2.88,8.61v.36Zm-6.97-3.98c-.09-1.04-.55-2.02-1.3-2.74-.73-.69-1.71-1.06-2.71-1.03-1.01-.05-1.99.29-2.75.94-.68.63-1.14,1.56-1.35,2.83h8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m234.46,30.2V10.13h6.68v4.73c.55-1.53,1.53-2.87,2.82-3.87,1.27-.88,2.79-1.34,4.33-1.29.28,0,.56,0,.84.03s.57.05.87.09l-.67,6.44c-.41-.14-.83-.24-1.25-.32-.39-.06-.79-.1-1.19-.1-1.72,0-3.05.53-3.99,1.58s-1.4,2.55-1.4,4.48v8.3h-7.03Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "136.46 22.58 131.82 30.78 114.21 .27 123.45 .27 136.46 22.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "164.8 .27 146.98 31.17 132.48 6.18 141.3 6.18 146.95 16.15 155.95 .27 164.8 .27"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIntelliwriter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/intelliwriter.aa1a3e40ff3558d0b34e25dea7de568d.svg";